// extracted by mini-css-extract-plugin
export default {"productgrid":"cart_productgrid__KlS9C","productcard":"cart_productcard__Bc67J"};